module.exports = __webpack_public_path__ + "img/cv.e8799f7e.svg";